var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#E4233B",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-253",
    fill: "#34CD4E",
    mask: "url(#mask-2)",
    points: "0 0 12 10 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-253",
    fill: "#34CD4E",
    mask: "url(#mask-2)",
    transform: "translate(22.000000, 10.000000) scale(-1, 1) translate(-22.000000, -10.000000) ",
    points: "16 0 28 10 16 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2824692,-1.91644623 L30.7736503,0.29432063 L18.454135,8.60353711 C18.5922336,9.04446151 18.6666667,9.51353836 18.6666667,10 C18.6666667,10.4864616 18.5922336,10.9555385 18.454135,11.3964629 L30.7736503,19.7056794 L29.2824692,21.9164462 L16.9622332,13.6061348 C16.1564623,14.2687994 15.1246946,14.6666667 14,14.6666667 C12.8757673,14.6666667 11.8443852,14.2691261 11.0387596,13.606951 L-1.2824692,21.9164462 L-2.77365027,19.7056794 L9.54586501,11.3964629 C9.40776645,10.9555385 9.33333333,10.4864616 9.33333333,10 C9.33333333,9.51353836 9.40776645,9.04446151 9.54586501,8.60353711 L-2.77365027,0.29432063 L-1.2824692,-1.91644623 L11.0387596,6.39304896 C11.8443852,5.73087387 12.8757673,5.33333333 14,5.33333333 C15.1246946,5.33333333 16.1564623,5.73120059 16.9622332,6.39386525 L29.2824692,-1.91644623 Z",
    id: "Rectangle-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.942809,10.3905243 L12.6666667,11.3333333 L12.942809,12.2761424 L12,12 L11.057191,12.2761424 L11.3333333,11.3333333 L11.057191,10.3905243 L12,10.6666667 L12.942809,10.3905243 Z M16.942809,10.3905243 L16.6666667,11.3333333 L16.942809,12.2761424 L16,12 L15.057191,12.2761424 L15.3333333,11.3333333 L15.057191,10.3905243 L16,10.6666667 L16.942809,10.3905243 Z M14.942809,7.05719096 L14.6666667,8 L14.942809,8.94280904 L14,8.66666667 L13.057191,8.94280904 L13.3333333,8 L13.057191,7.05719096 L14,7.33333333 L14.942809,7.05719096 Z",
    id: "Star-2",
    fill: "#DF2239",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.38d1fe9928f78c231581f2ebfc36a8f1.svg";
export { ForwardRef as ReactComponent };